import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";
import { useLang } from "../../lib/i18n";
import { LogoMark, LogoLockup } from "./Logo";

const FOOTER_LINK_KEYS = [
    { path: "/diensten", key: "diensten" },
    { path: "/werkgebied", key: "werkgebied" },
    { path: "/boeken", key: "boeken" },
    { path: "/contact", key: "contact" },
];

export const Footer = () => {
    const { t } = useLang();
    return (
    <footer data-testid="site-footer" className="border-t border-white/8 bg-night-950 pb-28 pt-16 md:pb-16">
        <div className="container-x">
            <div className="grid gap-12 md:grid-cols-3">
                <div>
                    <div className="flex items-center gap-3">
                        <LogoMark />
                        <LogoLockup />
                    </div>
                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
                        {t.footer.tagline}
                    </p>
                </div>
                <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">{t.footer.contactTitle}</p>
                    <a
                        href={PHONE_TEL}
                        data-testid="footer-phone"
                        className="mt-4 flex items-center gap-2.5 font-mono text-lg font-bold tracking-wider text-white transition-colors hover:text-amber-300"
                    >
                        <Phone size={17} className="text-amber-400" /> {PHONE_DISPLAY}
                    </a>
                    <p className="mt-3 text-sm text-slate-400">{t.footer.available}</p>
                    <p className="mt-1 text-sm text-slate-400">{t.footer.place}</p>
                </div>
                <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">{t.footer.navTitle}</p>
                    <nav className="mt-4 flex flex-col gap-2.5">
                        {FOOTER_LINK_KEYS.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                data-testid={`footer-link-${link.key}`}
                                className="w-fit text-sm text-slate-400 transition-colors hover:text-amber-300"
                            >
                                {t.nav[link.key]}
                            </Link>
                        ))}
                    </nav>
                </div>
            </div>
            <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/8 pt-7 sm:flex-row">
                <p className="text-xs text-slate-500" data-testid="footer-copyright">© 2026 Taxi Drunnen</p>
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-600">
                    {t.footer.slogan}
                </p>
            </div>
        </div>
    </footer>
    );
};
